import React from 'react';
import { styled } from 'styled-components';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import colors from '../styles/colors';

const StyledDivider = styled.div`
  margin-bottom: 2.5rem;
  border-top: 1px solid ${colors.neutral.grey200};
`;

const StyledHeader = styled(Text)`
  &&& {
    text-align: center;
    margin: 0.67em 0;
  }
`;

const FollowUpAppHeader: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.followup.headerTitle');

  return (
    <>
      <StyledHeader tagName="h1" textStyle="Heading.M" aria-label={title}>
        {title}
      </StyledHeader>
      <StyledDivider />
    </>
  );
};

export default FollowUpAppHeader;
